import { render, staticRenderFns, recyclableRender, components } from "./uni-list.vue?vue&type=template&id=34219f38&scoped=true&"
var renderjs
import script from "./uni-list.vue?vue&type=script&lang=js&"
export * from "./uni-list.vue?vue&type=script&lang=js&"
import style0 from "./uni-list.vue?vue&type=style&index=0&id=34219f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!C:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34219f38",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uni-list/uni-list.vue"
export default component.exports